module.exports = __webpack_public_path__ + "img/data.a3d833fd.svg";